import { render, staticRenderFns } from "./client-schools-table.vue?vue&type=template&id=18ca81e6"
import script from "./client-schools-table.vue?vue&type=script&lang=js"
export * from "./client-schools-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports